import React from 'react';
import { connect } from 'react-redux';

import './person.css';
import { systemText } from '../../../helpers/string';
import FormLabel from '../formLabel';

export class People extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			searchAvailable: '',
			searchSelected: '',
			selectedValues: props.value || [],
		};

		this.add = this.add.bind(this);
		this.remove = this.remove.bind(this);
	}

	componentWillReceiveProps(newProps) {
		this.setState({ selectedValues: newProps.value || [] });
	}

	add(id) {
		const selectedValues = [...this.state.selectedValues, id];
		this.setState({ selectedValues });
		this.props.onChange && this.props.onChange(selectedValues);
	}

	remove(id) {
		const selectedValues = this.state.selectedValues.filter(v => v !== id);
		this.setState({ selectedValues });
		this.props.onChange && this.props.onChange(selectedValues);
	}

	render() {
		const { blobImage, help, error, warning, label, exclude, disabled, disabledMessage, profiles, showFormHelp } =
			this.props;

		if (!profiles) return null;

		const max = this.props.max || 10;
		const { searchAvailable, searchSelected, selectedValues } = this.state;

		let available = [];
		let selected = [];

		const isExcluded = p => exclude && exclude.filter(e => e === p.id).length > 0;
		const isSelected = p =>
			selectedValues &&
			selectedValues.filter(e => e === p.id).length > 0 &&
			p.full_Name.toLowerCase().indexOf(searchSelected.toLowerCase()) >= 0;
		const isAvaliable = p =>
			(!selectedValues || selectedValues.filter(e => e === p.id).length === 0) &&
			p.full_Name.toLowerCase().indexOf(searchAvailable.toLowerCase()) >= 0;

		profiles.forEach(p => {
			if (isExcluded(p)) return;
			if (isSelected(p)) selected = [...selected, p];
			if (isAvaliable(p)) available = [...available, p];
		});

		const st = (path, ...rest) => systemText(`General/Controls/PersonPicker/${path}`, ...rest);

		const person = (p, f, title) => {
			const isDisabled = disabled && disabled.some(d => d === p.id);
			const message = isDisabled ? (disabledMessage ? disabledMessage : '') : title;

			return (
				<div
					key={`person-${p.id}`}
					title={message}
					className={`flex flex-center mb5 ${isDisabled ? 'disabled' : 'pointer'}`}
					onClick={isDisabled ? undefined : () => f(p.id)}
				>
					<div className="image-holder mr10">{blobImage({ folder: 'avatar', src: p.avatar })}</div>
					<div className="flex-grow">
						<span>{p.full_Name}</span>
					</div>
				</div>
			);
		};

		const showMore = (extra, key) => (
			<div key={`show-more-${key}`} className="flex mb5 show-more">
				<div className="image-holder mr10" />
				<div className="flex-grow">
					<span>... {extra === 1 ? st('Extra/Singular', extra) : st('Extra/Plural', extra)}</span>
				</div>
			</div>
		);

		return (
			<div id="person-picker" className={`form-group ${error ? 'has-error' : warning ? 'has-warning' : ''}`}>
				<FormLabel {...this.props} />
				<div className="row">
					<div className="col-md-6">
						<div className="search">
							<input
								type="text"
								value={searchAvailable}
								onChange={e => this.setState({ searchAvailable: e.target.value })}
								placeholder={st('Available/Placeholder')}
							/>
						</div>
						<div className="mb5">
							<label>{st('Available/Title')}</label>
						</div>
						<div id="available-list">
							{available.map((p, i) => {
								if (i < max) return person(p, this.add, st('Available/Add'));
								if (i === max) return showMore(available.length - max, 'available');
								return null;
							})}
						</div>
					</div>
					<div className="col-md-6">
						<div className="search">
							<input
								type="text"
								value={searchSelected}
								onChange={e => this.setState({ searchSelected: e.target.value })}
								placeholder={st('Selected/Placeholder')}
							/>
						</div>
						<div className="mb5">
							<label>
								{st('Selected/Title')} ({selected.length})
							</label>
						</div>
						<div id="selected-list">
							{selected.map((p, i) => {
								if (i < max) return person(p, this.remove, st('Selected/Remove'));
								if (i === max) return showMore(selected.length - max, 'selected');
								return null;
							})}
						</div>
					</div>
				</div>
				{error && <span className="help-block">{typeof error === 'function' ? error() : error}</span>}
				{warning && <span className="help-block">{typeof warning === 'function' ? warning() : warning}</span>}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		showFormHelp: state.ui.showFormHelp,
	};
};

export default connect(mapStateToProps, null)(People);
